import { render } from "./IOPMedicalVital.vue?vue&type=template&id=45248b88&scoped=true"
import script from "./IOPMedicalVital.vue?vue&type=script&lang=js"
export * from "./IOPMedicalVital.vue?vue&type=script&lang=js"

import "./IOPMedicalVital.vue?vue&type=style&index=0&id=45248b88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45248b88"]])

export default __exports__